/**
 * * Capitalizes the first letter of each word in a string.
 * @param str
 */
import { store } from '@/store'

export function capitalize (str:string) : string {
  return str.toLowerCase().replace(/\b[a-z]/g, function (letter) {
    return letter.toUpperCase()
  })
}

/**
 * * Checks if the logged in user has the specified permission.
 * @param permission
 */
export function can (permission: string) : boolean {
  return store.getters['authStore/permissions'].includes(permission)
}

/**
 * * Checks if the logged in user has ALL of the specified permissions
 * @param permissions
 */
export function canAll (permissions: string[]) : boolean {
  return store.getters['authStore/permissions'].every((p:string) => permissions.includes(p))
}

/**
 * * Checks if the logged in user has ANY of the specified permissions.
 * @param permissions
 */
export function canAny (permissions: string[]) : boolean {
  return store.getters['authStore/permissions'].some((p:string) => permissions.includes(p))
}
